import { Component, ElementRef, OnInit, OnDestroy, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AdminService } from '../../../../../services/admin.service';
import { UserService } from '../../../../../services/user.service';
import { SuggestionListsService } from '../../services/suggestion-lists.service';
import { ComponentBackgroundService } from '../../../../../services/component-background.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReviewSuggestionListsService } from '../../services/review-suggestion-lists.service';
import { ActionSlPopupComponent } from './popups/action-sl-popup/action-sl-popup.component';
import { CancelPopupComponent } from './popups/cancel-popup/cancel-popup.component';
import * as moment from 'moment';
import { User } from '../../../../../models/user.model';
import { HttpResponse } from '@angular/common/http';
import { HttpStatus, SuggestionListStatus, TaskStatus, SuggestionListStatusUtils } from './view-suggestion-list.constants';
import { SuggestionListUserOption } from './suggestion-list-user-option.model';
import { Subscription } from 'rxjs/Subscription';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { ECONOMIC_SECTIONS, suggestionPaysBackInHalfYear } from '../../models/suggestion-economics.model';
import { ConfirmationPopupComponent } from 'app/content-page/views/view-group/popups/confirmation-popup/confirmation-popup.component';

const SUGGESTION_AUTHOR_SAVED = 'SUGGESTION_AUTHOR_SAVED';
const HTTP_CONFLICT = 409;
const HTTP_FORBIDDEN = 403;
const SUGGESTION_ACCESS_DENIED = 'SUGGESTION_ACCESS_DENIED';


const SUGGESTION_WITHDRAW_CONFIRM = 'SUGGESTION_WITHDRAW_CONFIRM';
const OK = 'ok';
const NUMBER = 'number';
const ZERO_VALUE = 0;
const SUGGESTION_CONTENT_CONFLICT = 'SUGGESTION_CONTENT_CONFLICT';
const SUGGESTION_AUTHOR_FAILED = 'SUGGESTION_AUTHOR_FAILED';


const EMPTY_TEXT = '';
const PLEASE_CONTACT_THE_SERVER_SUPPORT = 'Please contact the server support.';
const MIN_CONTENT_LENGTH = 3;
const MAX_CONTENT_LENGTH = 80;


const ACTION_CREATE_CEO = 'createCEO';
const OBJECT_TYPE = 'object';
const BOOLEAN_TYPE = 'boolean';
const EMPTY_MESSAGE = '';
const STATUS_SEPARATOR = '_';
const STATUS_SPACE = ' ';
const DATE_FORMAT = 'YYYY-MM-DD';

interface SuggestionListResponse {
  body: {
    initiator: { id: string };
    daysToPostpone?: string;
    status: string;
    photoIds?: string[];
    group: { id: string };
    canManage?: boolean;
  };
}

@Component({
  selector: 'app-view-suggestion-list',
  templateUrl: './view-suggestion-list.component.html',
  styleUrls: ['./view-suggestion-list.component.css'],
  providers: [NgbActiveModal]
})
export class ViewSuggestionListComponent implements OnInit, OnDestroy {
  @ViewChild('contentName') set contentName(element: ElementRef) {
    if (element) { element.nativeElement.focus(); }
  }
  SuggestionListStatus = SuggestionListStatus;
  TaskStatus = TaskStatus;

  readonly economicSections = ECONOMIC_SECTIONS;
  editingContent = false;
  contentDraft = {name: EMPTY_TEXT, description: EMPTY_TEXT};
  authorBusy = false;
  authorMessage = EMPTY_TEXT;
  private readonly destroy$ = new Subject<void>();

  listID: string;
  notifyID: string;
  isLoaded = false;
  selectedSLList = null;
  economicPayback: boolean | null = null;
  chatVisible = false;
  msgText = '';
  showError = false;
  showSuccess = false;
  slGroup = null;
  groupHead = null;
  selfUserMe = null;
  isIInitiator = false;
  isIHead = false;
  isIMember = false;
  selectedRedirectDivision = null;
  allGroups: any[] = [];
  redirectResponseMsg = '';
  redirectShowMsg = false;
  disableRedirectBtn = false;
  headProblem = false;
  listOfTasksForHeads: any[] = [];
  suggestionListsServicegetFakeTable: any[] = [];
  firstDisable = false;
  dateOfPostpone;
  users: SuggestionListUserOption[] = [];
  create = false;
  redirect = false;
  postphone = false;
  user: User;
  isAdmin = false;
  isUser = false;
  isHead;
  iniciatorListId
  flag = false;
  initiatorList;
  groupDeputy;
  allGroupsList = [];
  currentUser;
  numberpostpone;
  numberRedirect;
  isRedirectGroupsLoading = false;
  isRedirectGroupsLoaded = false;
  isStaffedGroupOptionsLoading = false;
  isStaffedGroupOptionsLoaded = false;
  isCurrentGroupLoaded = false;
  isCurrentUserLoaded = false;
  photoUrls: SafeUrl[] = [];
  selectedPhotoUrl: SafeUrl = '';
  showPhotoModal: boolean = false;
  currentPhotoIndex: number = 0;
  private assignmentUsers: Subscription;

  constructor(private route: ActivatedRoute,
    public suggestionListsService: SuggestionListsService,
    public reviewSuggestionListsService: ReviewSuggestionListsService,
    public componentBackgroundService: ComponentBackgroundService,
    private userService: UserService,
    private adminService: AdminService,
    private router: Router,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.checkRole();
    this.suggestionListsService.firstDisableService = false;
    this.headProblem = false;
    this.reviewSuggestionListsService.clearOpenedSLID();
    this.isIInitiator = false;
    this.isIHead;
    this.msgText = '';
    this.showError = false;
    this.showSuccess = false;
    this.isLoaded = false;
    this.listID = this.route.snapshot.params['id'];
    this.notifyID = this.route.snapshot.params['notifyId'];
    this.reviewSuggestionListsService.setOpenedSLID(this.listID);
    this.redirectResponseMsg = '';
    this.redirectShowMsg = false;
    this.disableRedirectBtn = false;
    this.currentUser = JSON.parse(localStorage.getItem('User'));
    this.getListByiD();
    this.renameGroup();
  }

  renameGroup() {
    this.adminService.getModalSetting().subscribe(
        (res: any) => {
          this.numberpostpone = res.body.amountOfPossiblePostpones;
          this.numberRedirect = res.body.amountPossibleRedirections;
        }
      );
  }

  getListByiD(){
    this.suggestionListsService.getSLByID(this.listID).takeUntil(this.destroy$).subscribe(
      (res: SuggestionListResponse & {status: number}) => {
        if (res.status === HttpStatus.OK) {
          this.processSLResponse(res);
        } else {
          this.msgText = PLEASE_CONTACT_THE_SERVER_SUPPORT;
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      () => {
        this.msgText = PLEASE_CONTACT_THE_SERVER_SUPPORT;
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  private processSLResponse(res: SuggestionListResponse) {
    this.markNotify(this.listID);
    this.selectedSLList = res.body;
    this.economicPayback = this.selectedSLList.error ? null : suggestionPaysBackInHalfYear(this.selectedSLList.economics);
    this.listOfTasksForHeads = [];
    this.iniciatorListId = this.selectedSLList.initiator.id;
    this.dateOfPostpone = moment(this.selectedSLList.daysToPostpone).format(DATE_FORMAT);
    this.selectedSLList.status = this.selectedSLList.status.split(STATUS_SEPARATOR).join(STATUS_SPACE);

    if (this.selectedSLList.photoIds && this.selectedSLList.photoIds.length) {
      this.loadPhotos(this.selectedSLList.photoIds);
    }
    if (this.selectedSLList.status === SuggestionListStatus.POSTPONE) {
      this.create = false;
      this.redirect = false;
      this.postphone = true;
    }
    this.getUsersByIdGroup(res.body.group.id);
    this.isSLInProgressTasks();
    this.getCurrentSLDivision();
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION_ID"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
        this.isLoaded = false;
      }
    );
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }

  change(type) {
    if (type === 'create') {
      this.create = true;
      this.redirect = false;
      this.postphone = false;
    }
    if (type === 'redirect') {
      this.create = false;
      this.redirect = true;
      this.postphone = false;
      this.getAllGroups();
    }
    if (type === 'postphone') {
      this.create = false;
      this.redirect = false;
      this.postphone = true;
    }
  }

  private getStaffedGroupOptionsAndOpenModal(action: string) {
    if (this.isStaffedGroupOptionsLoaded) {
      this.openActionModal(action);
      return;
    }

    if (this.isStaffedGroupOptionsLoading) {
      return;
    }

    this.isStaffedGroupOptionsLoading = true;
    this.adminService.getStaffedGroupOptions().subscribe(
      (response: any) => {
        this.allGroupsList = response.status === HttpStatus.OK && Array.isArray(response.body)
          ? response.body.slice()
          : [];
        this.isStaffedGroupOptionsLoaded = true;
        this.isStaffedGroupOptionsLoading = false;
        this.openActionModal(action);
      },
      () => {
        this.allGroupsList = [];
        this.isStaffedGroupOptionsLoading = false;
        this.openActionModal(action);
      }
    );
  }

  getUsersByIdGroup(id: string) {
    if (!this.canManageCurrentSuggestion() || this.assignmentPending()) {
      return;
    }
    this.assignmentUsers = this.suggestionListsService.getAssignees(this.selectedSLList.id).subscribe(
      (response: HttpResponse<SuggestionListUserOption[]>) => {
        if (response.status === HttpStatus.OK) {
          this.users = this.prepareUsers(response.body);
        }
      }
    )
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.assignmentUsers) {
      this.assignmentUsers.unsubscribe();
    }
  }

  private prepareUsers(users: SuggestionListUserOption[]): SuggestionListUserOption[] {
    const copiedUsers = Array.isArray(users) ? users.filter(user => !!user).slice() : [];
    copiedUsers.sort((firstUser, secondUser) => this.compareUsers(firstUser, secondUser));
    return copiedUsers;
  }

  private compareUsers(firstUser: SuggestionListUserOption, secondUser: SuggestionListUserOption): number {
    const nameComparison = this.getUserSortValue(firstUser).localeCompare(this.getUserSortValue(secondUser));
    if (nameComparison !== 0) {
      return nameComparison;
    }
    return this.normalizeText(firstUser && firstUser.id).localeCompare(this.normalizeText(secondUser && secondUser.id));
  }

  private getUserSortValue(user: SuggestionListUserOption): string {
    const nameBySurname = [user && user.lastName, user && user.firstName, user && user.patronymicName]
      .map(value => this.normalizeText(value))
      .filter(value => value.length)
      .join(' ');

    return nameBySurname.length
      ? nameBySurname
      : this.normalizeText(user && user.fullName);
  }

  private normalizeText(value?: string): string {
    return typeof value === 'string' ? value.trim() : '';
  }

  changeVisibleChat() {
    this.chatVisible = this.chatVisible ? false : true;
  }

  getCurrentSLDivision() {
    this.isCurrentGroupLoaded = false;
    this.isCurrentUserLoaded = false;
    const slGroupID = this.selectedSLList.group.id;
    this.adminService.getGroupByID(slGroupID).subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.slGroup = res.body;
          this.selectedRedirectDivision = this.slGroup;
          this.processGroupLeadership();
          this.isCurrentGroupLoaded = true;
          this.completeCurrentUserRoleSetup();
        } else {
          this.msgText = 'Please contact the server support.';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      () => {
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
    this.getSelfMe();
  }

  private processGroupLeadership() {
    this.groupDeputy = this.slGroup.deputy || null;
    this.groupHead = this.slGroup.head || null;
    this.headProblem = !this.groupHead && !this.hasManagementDecision();
    if (!this.headProblem) {
      return;
    }
    this.msgText = EMPTY_MESSAGE;
    this.showError = true;
    this.showSuccess = false;
    this.isLoaded = true;
  }

  accept() {
    document.location.reload();
  }

  getSelfMe() {
    this.userService.getSelf().subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.selfUserMe = res.body;
          this.isCurrentUserLoaded = true;
          this.completeCurrentUserRoleSetup();
        } else {
          this.msgText = '';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      (err) => {
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  private completeCurrentUserRoleSetup() {
    if (this.isCurrentGroupLoaded && this.isCurrentUserLoaded) {
      this.processUserRoleAndTasks();
    }
  }

  private processUserRoleAndTasks() {
    this.isIInitiator = this.selfUserMe.id === this.selectedSLList.initiator.id;
    this.isIHead = this.canManageCurrentSuggestion();
    this.processUserTasks();
    this.reviewSuggestionListsService.setIsCurrentUserHead(this.isIHead);
    this.reviewSuggestionListsService.setIsCurrentUserInitiator(this.isIInitiator);
    this.reviewSuggestionListsService.setIsCurrentUserMember(this.isIMember);
    this.msgText = EMPTY_MESSAGE;
    this.isLoaded = true;
  }

  private hasManagementDecision(): boolean {
    return this.selectedSLList && typeof this.selectedSLList.canManage === BOOLEAN_TYPE;
  }

  private canManageCurrentSuggestion(): boolean {
    return !!this.selectedSLList && this.selectedSLList.canManage === true;
  }

  private processUserTasks() {
    if (this.selectedSLList.tasks !== null && this.selectedSLList.tasks !== undefined && this.selectedSLList.tasks.length > 0) {
      this.selectedSLList.tasks.forEach(task => {
        if (task.workerId === this.selfUserMe.id) {
          this.isIMember = true;
        }
      });
    } else {
      this.isIMember = false;
    }
  }

  private getAllGroups() {
    if (!this.isIHead || this.isRedirectGroupsLoading || this.isRedirectGroupsLoaded) {
      return;
    }

    this.isRedirectGroupsLoading = true;
    this.adminService.getAllGroupsHead().subscribe(
      (res: any) => {
        if (res.status === HttpStatus.OK) {
          this.allGroups = res.body;
          this.isRedirectGroupsLoaded = true;
          this.isRedirectGroupsLoading = false;
          this.msgText = '';
          this.isLoaded = true;
        } else {
          this.isRedirectGroupsLoading = false;
          this.msgText = '';
          this.showError = true;
          this.showSuccess = false;
          this.isLoaded = true;
        }
      },
      (err) => {
        this.isRedirectGroupsLoading = false;
        this.msgText = 'Please contact the server support.';
        this.showError = true;
        this.showSuccess = false;
        this.isLoaded = true;
      }
    );
  }

  selectGroup(group: any) {
    this.selectedRedirectDivision = group;
  }

  action(action) {
    if (this.assignmentPending() || this.authorBusy) { return; }
    if (action === ACTION_CREATE_CEO) {
      this.getStaffedGroupOptionsAndOpenModal(action);
      return;
    }

    this.openActionModal(action);
  }

  private openActionModal(action) {
    if (this.assignmentPending() || this.authorBusy) { return; }
    let modalRef;
    modalRef = this.modalService.open(ActionSlPopupComponent, {
      beforeDismiss: () => !modalRef.componentInstance.disableBtn
    });
    modalRef.componentInstance.setAction(action);
    modalRef.componentInstance.setSL(this.selectedSLList);
    modalRef.componentInstance.setDivisionId(this.selectedRedirectDivision.id, this.selectedSLList.id, this.notifyID);
    modalRef.componentInstance.setAllDevision(this.allGroupsList);
    modalRef.result.then(
      result => this.handleActionModalClose(result),
      reason => this.handleActionModalDismiss(action, reason)
    );
  }

  private handleActionModalClose(result): void {
    if (result === true) {
      this.refreshCurrentSuggestion();
    }
  }

  private handleActionModalDismiss(action, reason): void {
    if (action === ACTION_CREATE_CEO && reason && typeof reason === OBJECT_TYPE) {
      this.createCeoTask(reason);
    }
  }

  private refreshCurrentSuggestion(): void {
    this.isLoaded = false;
    this.listOfTasksForHeads = [];
    this.create = false;
    this.redirect = false;
    this.postphone = false;
    this.resetCurrentUserRelation();
    this.getListByiD();
  }

  private resetCurrentUserRelation(): void {
    this.groupHead = null;
    this.groupDeputy = null;
    this.isIHead = false;
    this.isIMember = false;
    this.headProblem = false;
  }

  createCeoTask(reason){
    if (this.assignmentPending() || this.authorBusy) { return; }
    this.authorBusy = true;
    this.suggestionListsService.sendToPlanfix(reason).takeUntil(this.destroy$).subscribe(
      () => { this.authorBusy = false; this.getListByiD(); },
      () => { this.authorBusy = false; this.authorMessage = SUGGESTION_AUTHOR_FAILED; this.getListByiD(); }
    );
  }

  cancelPostponement() {
    if (this.assignmentPending() || this.authorBusy) { return; }
    let modalRef;
    modalRef = this.modalService.open(CancelPopupComponent, {
      beforeDismiss: () => !modalRef.componentInstance.disableBtn
    });
    modalRef.componentInstance.setSL(this.selectedSLList, this.notifyID);
    modalRef.result.then(
      result => this.handleActionModalClose(result),
      () => {}
    );
  }

  isSLInProgressTasks() {
    if (SuggestionListStatusUtils.isInProgressStatus(this.selectedSLList.status)) {
      if (this.selectedSLList.hasOwnProperty('tasks')) {
        if (this.selectedSLList.tasks !== null && this.selectedSLList.tasks !== undefined) {
          if (Array.isArray(this.selectedSLList.tasks)) {
            this.listOfTasksForHeads = this.listOfTasksForHeads.concat(this.selectedSLList.tasks);
          } else {
            this.listOfTasksForHeads.push(this.selectedSLList.tasks);
          }
        }
      }
    }
  }

  showTasksProgress() {
    return SuggestionListStatusUtils.isInProgressStatus(this.selectedSLList.status) && this.listOfTasksForHeads.length > 0;
  }

  disabledByStatus() {
    let isDisabled = false;
    if (this.selectedSLList.status !== SuggestionListStatus.NEW) {
      if (this.selectedSLList.status === SuggestionListStatus.EXECUTING_TASKS || 
          this.selectedSLList.status === SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE) {
        isDisabled = this.isAllTasksCompleted();
      } else {
        isDisabled = this.handleReviewingStatus(isDisabled);
      }
    } else {
      isDisabled = true;
    }
    return isDisabled;
  }

  private handleReviewingStatus(isDisabled: boolean) {
    if (this.selectedSLList.status === SuggestionListStatus.REVIEWING) {
      isDisabled = this.isAllTasksCompleted();
    } else {
      isDisabled = this.handlePostponeExpiredStatus(isDisabled);
    }
    return isDisabled;
  }

  private handlePostponeExpiredStatus(isDisabled: boolean) {
    if (this.selectedSLList.status === SuggestionListStatus.POSTPONE_EXPIRED ||
      this.selectedSLList.status === SuggestionListStatus.POSTPONE_EXPIRED_UNDERSCORE) {
      isDisabled = true;
    } else {
      isDisabled = this.handleSuggestionTasksExpiredStatus(isDisabled);
    }
    return isDisabled;
  }

  private handleSuggestionTasksExpiredStatus(isDisabled: boolean) {
    if (this.selectedSLList.status === SuggestionListStatus.SUGGESTION_TASKS_EXPIRED ||
      this.selectedSLList.status === SuggestionListStatus.SUGGESTION_TASKS_EXPIRED_UNDERSCORE) {
      isDisabled = true;
    } else {
      isDisabled = false;
    }
    return isDisabled;
  }

  isAllTasksCompleted() {
    let isDone = true;
    this.listOfTasksForHeads.forEach(st => {
      if (st.status !== TaskStatus.DONE && st.status !== TaskStatus.COMPLETED) {
        isDone = false;
      }
    });
    return isDone;
  }

  canModifySuggestion(): boolean {
    return !SuggestionListStatusUtils.isFinalStatus(this.selectedSLList && this.selectedSLList.status);
  }

  isActionableHead(): boolean {
    return this.isIHead && this.canModifySuggestion() && !this.assignmentPending() && !this.authorBusy;
  }

  isActiveStatus(): boolean {
    return !SuggestionListStatusUtils.isFinalStatus(this.selectedSLList && this.selectedSLList.status);
  }

  canBePostponed(): boolean {
    return (this.selectedSLList && this.selectedSLList.status !== SuggestionListStatus.POSTPONE) && 
           (this.selectedSLList && this.selectedSLList.amountOfPossiblePostpones < this.numberpostpone);
  }

  canBeRedirected(): boolean {
    return this.selectedSLList && this.selectedSLList.numberRedirects < this.numberRedirect;
  }

  canCreateTasks(): boolean {
    return SuggestionListStatusUtils.isCreatableStatus(this.selectedSLList && this.selectedSLList.status);
  }

  shouldShowTaskProgress(): boolean {
    return SuggestionListStatusUtils.isInProgressStatus(this.selectedSLList && this.selectedSLList.status) && this.listOfTasksForHeads.length > 0;
  }

  canCancelSuggestion(): boolean {
    return !this.assignmentPending() && !this.authorBusy
      && (this.selectedSLList.status === SuggestionListStatus.POSTPONE || this.disabledByStatus());
  }

  shouldShowImplementationMembers(): boolean {
    return this.isActionableHead() && 
           !this.suggestionListsService.firstDisableService && 
           this.disabledByStatus() &&
           this.create;
  }

  shouldShowTaskLinks(): boolean {
    return (this.selectedSLList && this.selectedSLList.tasks && this.selectedSLList.tasks.url) && 
           (this.selectedSLList && this.selectedSLList.status !== SuggestionListStatus.EXECUTING_TASKS);
  }

  shouldShowEmptyTaskMessage(): boolean {
    return this.listOfTasksForHeads.length < 1 && 
           (this.selectedSLList && this.selectedSLList.status === SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE);
  }

  showAdminActionButtons(): boolean {
    return (this.selectedSLList && this.selectedSLList.status === SuggestionListStatus.APPROVE_CANCELLED) && 
           this.canManageCurrentSuggestion() && !this.assignmentPending() && !this.authorBusy;
  }

  showCancelButton(): boolean {
    return this.canManageCurrentSuggestion() && !this.assignmentPending()
      && (this.selectedSLList.status === SuggestionListStatus.POSTPONE
        || SuggestionListStatusUtils.isCreatableStatus(this.selectedSLList.status));
  }

  showAcceptButton(): boolean {
    return (this.selectedSLList && this.selectedSLList.status === SuggestionListStatus.CANCELLED) && !!this.notifyID;
  }

  showPostponeControls(): boolean {
    return this.postphone && 
           this.reviewSuggestionListsService.getIsCurrentUserHead() && 
           this.canCreateTasks();
  }

  showRedirectDropdown(): boolean {
    return this.reviewSuggestionListsService.getIsCurrentUserHead() && 
           !this.shouldShowTaskProgress() && 
           this.canCreateTasks();
  }

  isRedirectButtonDisabled(): boolean {
    return !!(this.selectedRedirectDivision &&
      this.slGroup &&
      this.selectedRedirectDivision.id !== this.slGroup.id &&
      this.reviewSuggestionListsService.getIsCurrentUserHead());
  }

  showRedirectInputReadonly(): boolean {
    return !this.reviewSuggestionListsService.getIsCurrentUserHead() || 
           this.shouldShowTaskProgress() || 
           !this.canCreateTasks();
  }

  trackEconomicSection(index: number, section: {key: string}): string { return section.key; }

  assignmentPending(): boolean {
    return !!this.selectedSLList && this.selectedSLList.assignmentPending === true;
  }

  startContentEdit() {
    if (!this.selectedSLList || this.selectedSLList.canEditContent !== true || this.authorBusy) { return; }
    this.contentDraft = {name: this.selectedSLList.template || EMPTY_TEXT, description: this.selectedSLList.description || EMPTY_TEXT};
    this.authorMessage = EMPTY_TEXT;
    this.editingContent = true;
  }

  contentDraftValid(): boolean {
    return this.contentDraft.name.trim().length >= MIN_CONTENT_LENGTH && this.contentDraft.name.trim().length <= MAX_CONTENT_LENGTH
      && this.contentDraft.description.trim().length >= MIN_CONTENT_LENGTH;
  }

  saveContent() {
    if (this.authorBusy || this.selectedSLList.canEditContent !== true || !this.contentDraftValid() || !this.hasMutationVersion()) { return; }
    this.authorBusy = true;
    this.authorMessage = EMPTY_TEXT;
    this.suggestionListsService.updateContent(this.listID, {name: this.contentDraft.name.trim(),
      description: this.contentDraft.description.trim(), expectedVersion: this.selectedSLList.mutationVersion}).takeUntil(this.destroy$).subscribe(
      (response) => this.authorActionSucceeded(response), error => this.authorActionFailed(error));
  }

  confirmWithdraw() {
    if (this.authorBusy || this.selectedSLList.canWithdraw !== true || !this.hasMutationVersion()) { return; }
    const version = this.selectedSLList.mutationVersion;
    const modal = this.modalService.open(ConfirmationPopupComponent);
    modal.componentInstance.massage = SUGGESTION_WITHDRAW_CONFIRM;
    modal.result.then(result => {
      if (result !== OK || this.authorBusy) { return; }
      this.authorBusy = true;
      this.authorMessage = EMPTY_TEXT;
      this.suggestionListsService.withdraw(this.listID, null, version).takeUntil(this.destroy$).subscribe(
        response => this.authorActionSucceeded(response), error => this.authorActionFailed(error));
    }, () => {});
  }

  private hasMutationVersion(): boolean {
    const version = this.selectedSLList.mutationVersion;
    if (typeof version === NUMBER && version >= ZERO_VALUE && Math.floor(version) === version) { return true; }
    this.authorMessage = SUGGESTION_CONTENT_CONFLICT;
    this.getListByiD();
    return false;
  }

  private authorActionSucceeded(response: SuggestionListResponse & {status: number}) {
    this.authorBusy = false;
    if (response.status !== HttpStatus.OK || !response.body) {
      this.authorMessage = SUGGESTION_AUTHOR_FAILED; return;
    }
    this.editingContent = false;
    this.authorMessage = SUGGESTION_AUTHOR_SAVED;
    this.processSLResponse(response);
  }

  private authorActionFailed(error: {status: number}) {
    this.authorBusy = false;
    this.authorMessage = error.status === HTTP_CONFLICT ? SUGGESTION_CONTENT_CONFLICT
      : error.status === HTTP_FORBIDDEN ? SUGGESTION_ACCESS_DENIED : SUGGESTION_AUTHOR_FAILED;
    if (error.status === HTTP_CONFLICT) { this.getListByiD(); }
  }

  loadPhotos(photoIds: string[]) {
    this.photoUrls = [];
    
    photoIds.forEach(photoId => {
      this.suggestionListsService.getPhotoById(photoId).subscribe(
        (res: any) => {
          if (res.status === HttpStatus.OK && res.body) {
            const photoUrl = URL.createObjectURL(res.body);
            const safeUrl = this.sanitizer.bypassSecurityTrustUrl(photoUrl);
            this.photoUrls.push(safeUrl);
          }
        },
        (error) => {
          console.error('Photo loading failed for id:', photoId, error);
        }
      );
    });
  }

  openPhotoModal(photoUrl: SafeUrl) {
    this.currentPhotoIndex = this.photoUrls.indexOf(photoUrl);
    this.selectedPhotoUrl = photoUrl;
    this.showPhotoModal = true;
  }

  closePhotoModal() {
    this.showPhotoModal = false;
    this.selectedPhotoUrl = '';
  }

  nextPhoto() {
    if (this.currentPhotoIndex < this.photoUrls.length - 1) {
      this.currentPhotoIndex++;
      this.selectedPhotoUrl = this.photoUrls[this.currentPhotoIndex];
    }
  }

  previousPhoto() {
    if (this.currentPhotoIndex > 0) {
      this.currentPhotoIndex--;
      this.selectedPhotoUrl = this.photoUrls[this.currentPhotoIndex];
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.showPhotoModal) {
      this.closePhotoModal();
    }
  }

  @HostListener('document:keydown.arrowleft', ['$event'])
  onArrowLeft(event: KeyboardEvent) {
    if (this.showPhotoModal) {
      this.previousPhoto();
    }
  }

  @HostListener('document:keydown.arrowright', ['$event'])
  onArrowRight(event: KeyboardEvent) {
    if (this.showPhotoModal) {
      this.nextPhoto();
    }
  }

  trackByPhotoIndex(index: number, photoUrl: SafeUrl): number {
    return index;
  }

  trackByHistoryId(index: number, history: any): string {
    return history.id ? history.id.toString() : index.toString();
  }

  trackByGroupId(index: number, group: any): string {
    return group.id ? group.id.toString() : index.toString();
  }

  trackByTaskParticipant(index: number, divisionAndHead: any): string {
    const workerId = divisionAndHead.workerId || divisionAndHead.id || '';
    const groupId = (divisionAndHead.group && divisionAndHead.group.id) || '';
    return `${workerId}-${groupId}` || index.toString();
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/view-suggestion-list.component.ts